const COMPANY_POLICIES = {
    LANDING_PAGE: {
        RESOURCE_ID: 'companyPolicies',
    },
    HANDBOOKS_LIST: {
        RESOURCE_ID: 'handbookList',
    },
    HANDBOOKS_CUSTOM_POLICY_LIST: {
        RESOURCE_ID: 'customlistPolicies',
    },
    DOCUMENT_SIGNATURES: {
        RESOURCE_ID: 'documentSignatures',
    },
    ESIGNATURE_MANAGEMENT: {
        RESOURCE_ID: 'eSignatureManagement',
    },
    ESIGNATURE_REPORTING: {
        RESOURCE_ID: 'eSignatureReporting',
    },
};

export default COMPANY_POLICIES;
